import { Currency } from "../../shared";
import { Effect, ParseResult, Schema } from "effect";
const ZeroCurrencies = new Set([
    "BIF",
    "CLP",
    "DJF",
    "GNF",
    "JPY",
    "KMF",
    "KRW",
    "MGA",
    "PYG",
    "RWF",
    "UGX",
    "VND",
    "VUV",
    "XAF",
    "XOF",
    "XPF"
]);
export const FromCurrency = Schema.transformOrFail(Currency.Code.ISO4217.Schema, Currency.Amount.UnitAmount.Schema, {
    encode: (to, _, ast, from)=>ParseResult.fail(new ParseResult.Forbidden(ast, from)),
    decode: (value)=>Effect.gen(function*() {
            if (ZeroCurrencies.has(value)) {
                return Currency.Amount.UnitAmount.Zero;
            }
            return Currency.Amount.UnitAmount.Centis;
        }),
    strict: true
});
